import React from 'react'
import { Link } from 'gatsby'
import Navigation from './navigation'

const Header = () => (
  <header>
    <div className="header-title">
      <Link to="/">
        <span className="title">Zane <span className="title-surname">Staggs</span></span>
      </Link>
    </div>
    <Navigation />
  </header>
)

export default Header
